import { type Cart } from "@client/content/modules/Cart/types";
import { OrderItemLine } from "@client/content/modules/OrderConfirmation/Content/component";
import date from "@client/lib/date";
import { formatMoneyDisplay } from "@client/lib/format";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormat } from "@common/lib/i18n";
import { groupBy, values } from "lodash";
import * as React from "react";
import { type Checkout } from "../../types";

type ItemProps = {
  currencyCode: string;
  info: Cart.Api.SubscriptionInfo;
  quantity: number;
};
const Item = (props: ItemProps) => {
  const i18n = useI18n();

  return (
    <>
      <span>{`${formatMoneyDisplay(props.info.repeatSalesPrice * props.quantity, props.currencyCode)} /${
        props.info.repeatInterval > 1 ? ` ${props.info.repeatInterval}` : ""
      } ${props.info.repeatIntervalTimeUnit.toLowerCase()}`}</span>
      <span className="hint">
        {!!props.info.repeatLimit && !!props.info.repeatDay
          ? i18nFormat(
              props.info.repeatLimit > 1 ? i18n.nPaymentsStarting : i18n.onePaymentStarting,
              ["N", props.info.repeatLimit],
              ["DATE", date.formatDate(props.info.nextRepeatDate)]
            )
          : !!props.info.repeatLimit
          ? i18nFormat(props.info.repeatLimit > 1 ? i18n.nPayments : i18n.onePayment, ["N", props.info.repeatLimit])
          : !!props.info.repeatDay
          ? i18nFormat(i18n.starting, ["DATE", date.formatDate(props.info.nextRepeatDate)])
          : null}
      </span>
    </>
  );
};

type Props = {
  currencyCode: string;
  items: Checkout.CartItem[];
};
const OrderSubscriptions = (props: Props) => {
  const i18n = useI18n();

  const subscriptions = React.useMemo(
    () =>
      props.items
        .filter((x) => x.subscriptionInfo)
        .map((x) => ({
          key: JSON.stringify(x.subscriptionInfo),
          info: x.subscriptionInfo!,
          quantity: x.quantity
        })),
    [props.items]
  );

  if (!subscriptions.length) return null;

  const groupped = values(groupBy(subscriptions, (x) => x.key)).map((x) => ({
    info: x[0].info,
    quantity: x.reduce((res, y) => res + y.quantity, 0)
  }));
  return (
    <div className="wsc_order_subscriptions">
      <OrderItemLine name={i18n.subscriptionTotal} qa="Subscription total">
        {groupped.map((x, i) => (
          <p className="summary" key={i}>
            <Item info={x.info} currencyCode={props.currencyCode} quantity={x.quantity} />
          </p>
        ))}
      </OrderItemLine>
    </div>
  );
};
export default OrderSubscriptions;
